import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { InwardMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { useNavigate } from 'react-router-dom';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { selectCloths, selectFirm, selectlocationdata, selectParty, selectPINos, selectRack, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { createDirectPurInwEntry, fetchPINo } from '../../Store/PHPSlice/Inward/PurchaseInward';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchLocationData, fetchTransportData } from '../../Store/PHPSlice/Transport';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const DirectPurchaseInwEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        prdt: getCurrentDate(),
        firm: '',
        tQtyM: '',
        clothId: '',
        amt: '',
        PiNo: '',
        partyId: '',
        taxAmt: '',
        fAmt: '',
        lrdt: '',
        lrno: '',
        transpt: '',
        locId: '',
        bill: '',
        userId: userdata?.ID
    });
    const [tableRows, setTableRows] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openBale, setOpenBale] = useState(false);
    const [noOfBales, setNoOfBales] = useState(0);
    const [rows, setRows] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [loading, setLoading] = useState(false);
    const actionMap = {
        clothId: fetchClothData,
        partyId: fetchPartyData,
        transpt: fetchTransportData
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const clothlist = useSelector(selectCloths);
    const partyList = useSelector(selectParty);
    const PiNo = useSelector(selectPINos);
    const firmList = useSelector(selectFirm);
    const transptList = useSelector(selectTransports);
    const racklist = useSelector(selectRack);
    const loclist = useSelector(selectlocationdata);
    useEffect(() => {
        dispatch(fetchClothData());
        dispatch(fetchPartyData());
        dispatch(fetchPINo());
        dispatch(fetchCompanyData());
        dispatch(fetchTransportData());
        dispatch(fetchLocationData());
        dispatch(fetchRackData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (PiNo.data) {
            var Pi = PiNo.data.piNo;
            setFormData((prevFormData) => ({
                ...prevFormData,
                PiNo: Pi
            }));
        }
    }, [PiNo]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const handleNavitoCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // navigate('/NewClothEntry');
    };

    const handleNavitoParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // navigate('/NewPartyEntry');
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));
        if (dropdownType === 'clothId' && value) {
            const selCloth = clothlist.data.length > 0 ? clothlist.data.find((item) => item.ID === value) : [];

            if (selCloth) {
                const { ID, clothNm, uom, hsn, model, color, panna_size, shadeNo } = selCloth;
                const newRow = {
                    clothId: ID,
                    cloth: `${clothNm} ${model} ${color} ${shadeNo} ${panna_size}`,
                    hsn: hsn,
                    unit: uom,
                    deliveryDate: '',
                    rate: '0',
                    meter: '0',
                    amount: '0',
                    IGST: '5',
                    IGSTAmt: '0',
                    CGST: '2.5',
                    CGSTAmt: '0',
                    SGST: '2.5',
                    SGSTAmt: '0',
                    bale: '',
                    details: '',
                    netAmt: ''
                };
                setTableRows([...tableRows, newRow]);
            }
            setTimeout(() => {
                setFormData({
                    ...formData,
                    cloth: ''
                });
            }, 1000);

        }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };

    const handleRowInputChange = (index, e) => {
        const { name, value } = e.target;
        const newRows = [...tableRows];
        newRows[index][name] = value;
        if (name === 'rate' || name === 'meter' || name === 'amount' || name === 'IGST' ||
            name === 'IGSTAmt' || name === 'CGST' || name === 'CGSTAmt' || name === 'SGST' ||
            name === 'SGSTAmt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        // Calculate IGSTAmt based on state_type and IGST percentage

        // state type =
        //  inside - 0
        // outside - 1
        var totalTaxAmt = 0;
        if (formData.vender !== '') {
            if (name === 'rate' || name === 'meter') {
                const rate = parseFloat(newRows[index]['rate']) || 0;
                const meter = parseFloat(newRows[index]['meter']) || 0;
                newRows[index]['amount'] = (rate * meter).toFixed(2);

                // Calculate CGST and SGST amounts based on amount
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;
                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = 0;
                newRows[index]['netAmt'] = amount + parseFloat(newRows[index]['CGSTAmt']) + parseFloat(newRows[index]['SGSTAmt']) || 0;

            }
            const stateType = partyList?.data?.length > 0 ? partyList?.data?.find((item) => item.ID === formData.partyId) : '';

            if (stateType.state_type === '1' || name === 'IGST' || name === 'amount') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const IGSTPercent = parseFloat(newRows[index]['IGST']) || 0;
                newRows[index]['IGSTAmt'] = ((amount * IGSTPercent) / 100).toFixed(2);
                newRows[index]['CGSTAmt'] = '0';
                newRows[index]['SGSTAmt'] = '0';
                newRows[index]['netAmt'] = amount + parseFloat(newRows[index]['IGSTAmt']) || 0;
                var totalTaxAmt = newRows.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0);


            }

            if (stateType.state_type === '0' || name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';
                newRows[index]['netAmt'] = amount + parseFloat(newRows[index]['CGSTAmt']) + parseFloat(newRows[index]['SGSTAmt']) || 0;

                var cgst1 = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst1 = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst1 + sgst1;


            }
            if (name === 'amount' || name === 'CGST' || name === 'SGST') {
                const amount = parseFloat(newRows[index]['amount']) || 0;
                const CGSTPercent = parseFloat(newRows[index]['CGST']) || 0;
                const SGSTPercent = parseFloat(newRows[index]['SGST']) || 0;

                newRows[index]['CGSTAmt'] = ((amount * CGSTPercent) / 100).toFixed(2);
                newRows[index]['SGSTAmt'] = ((amount * SGSTPercent) / 100).toFixed(2);
                newRows[index]['IGSTAmt'] = '0';
                newRows[index]['netAmt'] = amount + parseFloat(newRows[index]['CGSTAmt']) + parseFloat(newRows[index]['SGSTAmt']) || 0;

                var cgst = newRows.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst = newRows.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = cgst + sgst;

            }

            const totalMeter = newRows.reduce((total, row) => total + parseFloat(row.meter || 0), 0)
            const totalAmount = newRows.reduce((total, row) => total + parseFloat(row.amount || 0), 0);
            const finalAmt = totalTaxAmt + totalAmount;


            const updatedFormData = {
                ...formData,
                amt: totalAmount.toFixed(2),
                tQtyM: totalMeter.toFixed(2),
                taxAmt: totalTaxAmt.toFixed(2),
                fAmt: finalAmt.toFixed(2),

            };

            // Update tableRows state
            setTableRows(newRows);
            // Update formData state
            setFormData(updatedFormData);
        }

        const updatedRows = tableRows.map((row, i) => (i === index ? { ...row, [name]: value } : row));

        if (name === 'bale') {
            const Id = updatedRows[index].clothId; // Extract clothId from the updated row
            setNoOfBales(value);
            setRows(Array.from({ length: value }, () => ({ bale: '', mtr: '0', location: '', Id: Id })));
            setTimeout(() => {
                handleAddButton();
            }, 1000);
        }
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.includes(index)) {
                const prev = prevSelectedRows.filter(rowIndex => rowIndex !== index);
                return prev;

            } else {

                const selectedRow = tableRows[index];

                let rate = parseFloat(selectedRow.rate) || 0;
                let qty = parseFloat(selectedRow.qty) || 0;
                let amnt = (rate * qty).toFixed(2);
                if (selectedRow.IGSTAmt !== '0') {
                    var taxAmnt = selectedRow.IGSTAmt;
                    var finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
                } else {
                    taxAmnt = parseFloat(selectedRow.CGSTAmt) + parseFloat(selectedRow.SGSTAmt);
                    finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
                }

                setFormData({
                    ...formData,
                    tQtyM: qty,
                    amt: amnt,
                    taxAmt: taxAmnt,
                    fAmt: finalAmnt,
                });

                return [...prevSelectedRows, index];
            }
        });
    };

    const handleAddButton = () => {
        setOpenBale(true);
    };

    const handleInputChanged = (index, field, value) => {
        if (field === 'mtr') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index][field] = value;
            return newRows;
        });
    };

    // const handleBaleSubmit = () => {
    //     const newData = rows.map((item) => (`${item.Id}||${item.bale}||${item.mtr}||${item.location}`));
    //     const updatedRows = tableRows.map((ele, index) => {
    //         if (selectedRows.includes(index)) {
    //             return {
    //                 ...ele,
    //                 details: newData
    //             };
    //         }
    //         return ele;
    //     });

    //     setTableRows(updatedRows);
    //     setOpenBale(false);
    // };

    const handleBaleClick = (index, clothId, meter) => {
        setCurrentIndex(index);
        // Construct the URL with query parameters or use a placeholder route
        const id = index + 1;

        const url = `/BaleLumpEntry/${id}-${clothId}-${meter}`;
        // console.log(tableRows);
        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');

        // // Set up a listener to receive data from the child
        // window.addEventListener('message', (event) => {
        //     // Ensure the event comes from the expected source
        //     if (event.origin !== window.location.origin) return;

        //     // Process the data received from the child
        //     // console.log('Data received from child:', event.data);
        //     const updateTable = [...tableRows];
        //     updateTable[index].bale = event.data;
        //     setTableRows(updateTable);
        //     // Update the parent state or perform any required action with the received data
        // });
    };


    function convertIntoOneObject(array, formData) {
        const mulDetails = [...array.map((item) => item.details)] || [];
        const tableData = {

            netAmt: [...array.map((item) => item.netAmt)],
            clothId: [...array.map((item) => item.clothId)],
            rate: [...array.map((item) => item.rate)],
            mtr: [...array.map((item) => item.meter)],
            amount: [...array.map((item) => item.amount)],
            IGST: [...array.map((item) => item.IGST)],
            CGST: [...array.map((item) => item.CGST)],
            SGST: [...array.map((item) => item.SGST)],
            IGSTAmt: [...array.map((item) => item.IGSTAmt)],
            CGSTAmt: [...array.map((item) => item.CGSTAmt)],
            SGSTAmt: [...array.map((item) => item.SGSTAmt)],
            baleNo: [...array.map((item) => item.bale)],
            details: mulDetails.reduce((acc, curr) => acc.concat(curr), []),

            // Include formData fields

            partyId: formData.partyId,
            firm: formData.firm,
            prdt: formData.prdt,
            tQtyM: formData.tQtyM,
            PiNo: formData.PiNo,
            amt: formData.amt,
            taxAmt: formData.taxAmt,
            fAmt: formData.fAmt,
            lrdt: formData.lrdt,
            lrno: formData.lrno,
            transpt: formData.transpt,
            locId: formData.locId,
            bill: formData.bill,
            userId: formData.userId
        };
        return tableData;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const finalObject = convertIntoOneObject(tableRows, formData);
            // console.log(finalObject);

            const result = await dispatch(createDirectPurInwEntry(finalObject)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Purchase Inward Added");
            alert("Purchase Inward Added");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    };


    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {
            const index = resendData?.index;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableRows];

            // let qty = updateTableData[index].meter;
            let rate = updateTableData[index].rate;
            const meter = parseFloat(totmtr);
            const amount = parseFloat(totmtr) * parseFloat(rate);

            updateTableData[index].meter = meter;
            updateTableData[index].amount = amount;

            // const tQtyM = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.inwQty), 0);
            // const amt = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.amount), 0);
            // const famt = amt + parseFloat(formData.taxAmt);

            setTableRows(updateTableData);
            // setFormData(prevFormData => ({
            //     ...prevFormData,
            //     tQtyM: tQtyM,
            //     amt: amt,
            //     fAmt: famt
            // }));
        }
        // Process the data (e.g., update state)
    };

    window.handleResendFromChild = handleResend;

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleNavigateCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistfirst = [
        {
            label: 'Cloth',
            id: 'clothId',
            options: clothlist?.data || [],
            value: formData.clothId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId'),
            getOptionLabel: (option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateCloth(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('clothId'),
            handleDropdownClose: () => handleDropdownClose('clothId'),
        },
        {
            label: 'Party',
            id: 'partyId',
            options: partyList?.data || [],
            value: formData.partyId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('partyId'),
            handleDropdownClose: () => handleDropdownClose('partyId'),
        }
    ];

    const dropdowntransport = [
        {
            label: 'Transport',
            id: 'transpt',
            options: transptList?.data || [],
            value: formData.transpt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'transpt', value: newValue ? newValue.transportNm : '' } }, 'transpt'),
            getOptionLabel: (option) => `${option.transportNm}` || '',
            isOptionEqualToValue: (option, value) => option.transportNm === value.transportNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.transportNm === value) || null;
                }
                return null;
            },
            handleAddNew: '',
            btnlabel: '',
            handleDropdownOpen: () => handleDropdownOpen('transpt'),
            handleDropdownClose: () => handleDropdownClose('transpt'),
        },
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    // console.log(firmList?.data)
    const dropdownFirm = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmList?.data || [],
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => `${option.firmNm}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: '',
            btnlabel: '',
            handleDropdownOpen: () => handleDropdownOpen('firm'),
            handleDropdownClose: () => handleDropdownClose('firm'),
        }
    ];

    const handleRemoveSelected = () => {
        setTableRows((prevRows) =>
            prevRows.filter((_, index) => !selectedRows.includes(index))
        );
        setSelectedRows([]); // Reset selection
    };

    return (
        <>
            <Titlebar data={InwardMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Direct Purchase Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="clothId">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="clothId"
                                                    id="clothId"
                                                    name="clothId"
                                                    value={formData.clothId}
                                                    onChange={(e) => handleDropdownChange(e, 'clothId')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        clothlist?.data?.length > 0 ? clothlist?.data?.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoCloth} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="partyId">Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="partyId"
                                                    id="partyId"
                                                    name="partyId"
                                                    value={formData.partyId}
                                                    onChange={(e) => handleDropdownChange(e, 'partyId')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        partyList.data.length > 0 ? partyList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.partyNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoParty} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {[

                                    { label: 'PI No', name: 'PiNo', type: 'readOnly' },
                                    { label: 'Purchase Date', name: 'prdt', type: 'date' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="firm"
                                                    id="firm"
                                                    name="firm"
                                                    value={formData.firm}
                                                    onChange={(e) => handleDropdownChange(e, 'firm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        firmList?.data.length > 0 ? firmList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.firmNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownFirm && dropdownFirm?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }


                                {[

                                    { label: 'Total Qty / Meter', name: 'tQtyM', type: 'readOnly' },
                                    { label: 'Amount', name: 'amt', type: 'readOnly' },
                                    { label: 'Tax Amount', name: 'taxAmt', type: 'readOnly' },
                                    { label: 'Final Amount', name: 'fAmt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'LR No', name: 'lrno' },
                                    { label: 'LR Date', name: 'lrdt', type: 'date' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name == 'PoNo' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="transpt">Transport Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="transpt"
                                                    id="transpt"
                                                    name="transpt"
                                                    value={formData.transpt}
                                                    onChange={(e) => handleDropdownChange(e, 'transpt')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        transptList.data.length > 0 ? transptList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.transportNm}>{item.transportNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {[
                                    { label: 'Bill/Challan No', name: 'bill' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {
                                    dropdowntransport && dropdowntransport?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleRemoveSelected} disabled={tableRows?.length === 0} >Remove</Button>
                                </Grid>

                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>HSN</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Unit</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Meter</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>No. Bale</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Details</TableCell> */}

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                    disabled={formData.partyId == ""}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.cloth}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.hsn}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.unit}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <input
                                                                    type='text'
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    name="bale"
                                                                    value={row.bale}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                />

                                                                
                                                            </TableCell> */}
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextareaAutosize
                                                                    name="details"
                                                                    value={row.details}
                                                                    inputProps={{ style: styled.txtArea, readOnly: !selectedRows.includes(index) }}
                                                                    style={{ padding: '6px' }}
                                                                />
                                                            </TableCell> */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>

                                                                <Button variant="contained" color="primary" size='small'
                                                                    onClick={() => handleBaleClick(index, row.clothId, row.meter)}
                                                                    disabled={!selectedRows.includes(index)}
                                                                >
                                                                    Add
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                {/* {openBale && (
                                    <div style={{ margin: '1% 10%' }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align="center">Bale</TableCell>
                                                    <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align="center">Mtr</TableCell>
                                                    <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align="center">Location</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                            <TextField
                                                                value={row.bale}
                                                                onChange={(e) => handleInputChanged(index, 'bale', e.target.value)}
                                                                inputProps={{ style: styled.inputTables }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                            <TextField
                                                                value={row.mtr}
                                                                onChange={(e) => handleInputChanged(index, 'mtr', e.target.value)}
                                                                inputProps={{ style: styled.inputTables }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                            <Select
                                                                value={row.location}
                                                                onChange={(e) => handleInputChanged(index, 'location', e.target.value)}
                                                                sx={{ width: '180px', height: '30px' }}
                                                            >
                                                                <MenuItem value="">Select an option</MenuItem>
                                                                {racklist.data.length > 0 ? racklist.data.map((item, index) => (
                                                                    <MenuItem key={index} value={item.rackNm}>{item.rackNm}</MenuItem>
                                                                )) : []}
                                                            </Select>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Button onClick={handleBaleSubmit} variant="contained" color="primary" sx={{ margin: '2% 10%' }}>
                                            Add
                                        </Button>
                                    </div>
                                )} */}


                                {tableRows?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default DirectPurchaseInwEntry;
